import moment from 'moment';

const pad = (number, width) => {
  const numString = String(number);
  const padding = Math.max(0, width - numString.length);
  return '0'.repeat(padding) + numString;
};

export const dateFormat = (date, format) => moment(date).format(format);

export const dateISO = (date) => moment(date).toISOString();

export const getStartOfDay = (date) => moment.utc(date).startOf('day');
export const getEndOfDay = (date) => moment.utc(date).endOf('day');

export const toHoursAndMinutes = (seconds) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  return `${pad(hours, 2)}h${pad(minutes, 2)}m`;
};
